module.exports = __webpack_public_path__ + "static/watermelon-fd1511c39d99b2e7d8b89cfc81152bc3.svg";